<div class="modal-header">
  <div class="preview-buttons">
    <h4 class="modal-title">Preview PDF <a class="material-icons" [href]="url" target="_blank">download</a></h4>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.close(false)"></button>
</div>
@if (loading) {
  <mat-spinner style="margin-left: 40%; margin-top: 11%"></mat-spinner>
}
<div class="modal-body">
  <pdf-viewer [src]="url" (after-load-complete)="loading = false" [render-text]="true"
    style="display: block; height: 100vh">
  </pdf-viewer>
</div>